import React, { EventHandler } from 'react';
import Button, { ButtonProps } from './Button';
import { Box } from 'rebass';

export type ButtonToggleProps = Omit<ButtonProps, 'value'> & {
  buttonOptions?: { label: any; value: any; onClick?: EventHandler<any> }[];
  name: string;
  value?: any;
  required?: boolean;
};

const ButtonToggle = (props: ButtonToggleProps) => {
  const {
    buttonOptions = [
      { label: 'Yes', value: true },
      { label: 'No', value: false },
    ],
    onClick,
    name,
    value,
    required,
  } = props;

  const hasValue =
    buttonOptions.findIndex((option) => option.value === value) !== -1;

  const borderStyle = {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: !hasValue && required ? 'statusError' : undefined,
  };

  return (
    <Box
      sx={{ whiteSpace: 'nowrap' }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      {buttonOptions.map((buttonOption, index) => {
        const extraStyle: any = {};
        switch (index) {
          // left
          case 0:
            extraStyle.borderTopRightRadius = 0;
            extraStyle.borderBottomRightRadius = 0;
            extraStyle.borderRightWidth = 0;
            break;

          // middle
          default:
            extraStyle.borderTopRightRadius = 0;
            extraStyle.borderBottomRightRadius = 0;
            extraStyle.borderTopLeftRadius = 0;
            extraStyle.borderBottomLeftRadius = 0;
            extraStyle.borderRightWidth = 0;
            break;

          // right
          case buttonOptions.length - 1:
            extraStyle.borderTopLeftRadius = 0;
            extraStyle.borderBottomLeftRadius = 0;
            break;
        }
        return (
          <Button
            {...(props as any)}
            key={buttonOption.value}
            name={name}
            onClick={
              value === buttonOption.value
                ? undefined
                : (buttonOption.onClick ?? onClick)
            }
            sx={{
              ...(props.sx ?? {}),
              ...borderStyle,
              ...extraStyle,
            }}
            value={buttonOption.value}
            variant={value === buttonOption.value ? 'secondary' : 'outline'}
          >
            {buttonOption.label}
          </Button>
        );
      })}
    </Box>
  );
};

export default ButtonToggle;
